var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    width: 11.1348,
    height: 18.5991,
    rx: 4.50069,
    transform: "matrix(1.0002 -0.00456468 -0.0535258 0.998892 7.99609 0.489258)",
    fill: "#5FD0FB",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9668 2.9541L14.0817 2.93369M8.20058 21.2527L15.0204 21.2255",
    stroke: "#011E29",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.4,
    y: 0.4,
    width: 13.2,
    height: 23.2,
    rx: 1.6,
    stroke: "#011E29",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileVertical);
export default __webpack_public_path__ + "static/media/mobile-vertical.0134004981ffb84677b9b7304f40717b.svg";
export { ForwardRef as ReactComponent };